import { render, staticRenderFns } from "./certiys.vue?vue&type=template&id=cb89705c"
import script from "./certiys.vue?vue&type=script&lang=js"
export * from "./certiys.vue?vue&type=script&lang=js"
import style0 from "./certiys.vue?vue&type=style&index=0&id=cb89705c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports